import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BrandLogo, { BrandWordmark } from './BrandLogo';

const Navbar = () => {
  const { user, mode, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Get mode-specific styling
  const getModeColor = () => {
    switch (mode) {
      case 'school':
        return 'bg-green-600 hover:bg-green-700';
      case 'college':
        return 'bg-purple-600 hover:bg-purple-700';
      case 'open':
      default:
        return 'bg-blue-600 hover:bg-blue-700';
    }
  };

  const getModeBadgeColor = () => {
    switch (mode) {
      case 'school':
        return 'bg-green-100 text-green-800';
      case 'college':
        return 'bg-purple-100 text-purple-800';
      case 'open':
      default:
        return 'bg-blue-100 text-blue-800';
    }
  };

  return (
    <nav className="bg-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to={`/${mode || 'open'}`} className="flex items-center gap-2.5">
              <BrandLogo size="sm" />
              <BrandWordmark size="lg" className="text-gray-900 dark:text-white" />
              {mode && (
                <span className={`ml-3 px-2 py-1 text-xs font-semibold rounded-full ${getModeBadgeColor()}`}>
                  {mode.charAt(0).toUpperCase() + mode.slice(1)} Mode
                </span>
              )}
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            {user && (
              <>
                <Link
                  to={`/${mode || 'open'}`}
                  className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
                >
                  Home
                </Link>
                <div className="text-gray-700 px-3 py-2 text-sm">
                  {user.name}
                </div>
                <button
                  onClick={handleLogout}
                  className={`${getModeColor()} text-white px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200`}
                >
                  Logout
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
